export default __webpack_public_path__ + "static/media/star_1.8fe410ca.svg";